<template>
	<div>
	<el-card class="box-card">
		<div style="padding:-20px">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/home/index' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>系统管理</el-breadcrumb-item>
				<el-breadcrumb-item>角色管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
	</el-card>
	
	<el-card class="box-card mainPadding" >
			<el-form :inline="true" :model="form" class="demo-form-inline" size="small">
				<el-form-item label="角色名称">
					<el-input v-model="form.role" placeholder="角色名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getData()" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="add()" icon="el-icon-plus">添加</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="tableData" stripe style="width: 100%">
				<el-table-column type="index" label="#">
				</el-table-column>
				<el-table-column prop="role" label="角色名称">
				</el-table-column>
				<el-table-column prop="cjDate" label="创建时间">
				</el-table-column>
				<el-table-column prop="xDate" label="修改时间">
				</el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#dcdfe6" disabled>
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" size="small" @click="edit(scope.$index,scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" size="small" @click="del(scope.$index,scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[10, 20, 30, 50]" :page-size="100" layout="total, prev, pager, next, jumper" :total="10">
			</el-pagination>
		</el-card>

		<!--添加弹窗-->
		<el-dialog :title="title" :visible.sync="dialogAddFormVisible" width="35%">
			<el-form :model="addForm" size="small" label-width="80px" :rules="rules">
				<el-form-item label="角色名称" prop="role">
					<el-input v-model="addForm.role" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="satus">
					<el-switch v-model="addForm.status" active-color="#13ce66" inactive-color="#dcdfe6">
					</el-switch>
				</el-form-item>
				<el-divider>请选择权限</el-divider>
				<el-tree :data="treeData" show-checkbox node-key="id" :props="defaultProps" default-expand-all>
				</el-tree>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogAddFormVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="dialogAddFormVisible = false" size="small">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//权限树
				treeData: [{
					id: 1,
					label: '系统管理',
					children: [{
						id: 5,
						label: '角色管理',
						children: [{
								id: 9,
								label: '角色添加'
							}, {
								id: 10,
								label: '角色删除'
							},
							{
								id: 11,
								label: '角色编辑'
							}
						]
					}, {
						id: 6,
						label: '用户管理',
						children: [{
								id: 12,
								label: '用户添加'
							}, {
								id: 13,
								label: '用户删除'
							},
							{
								id: 14,
								label: '用户编辑'
							}
						]

					}]
				}],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				//表格
				tableData: [{
						role: '管理员',
						xDate: '2020-02-01',
						cjDate: '2020-02-01',
						status: true

					},
					{
						role: '普通用户',
						xDate: '2020-02-28',
						cjDate: '2020-04-01',
						status: true

					}
				],
				//查询表单
				form: {
					home: '',
					name: ''
				},
				//添加表单
				addForm: {
					role: '',
					status: false
				},
				//权限弹窗
				dialogAddFormVisible: false,
				dialogqxFormVisible: false,
				rules: {
					home: [{
						required: true,
						message: '请输入同乡会',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
				},
				//弹窗标题
				title: '',
				currentPage4: 4

			}
		},
		created() {},
		methods: {
			//获取表格数据
			getData() {
				alert('getData')

			},
			//删除
			del(index,row) {
				this.$confirm('是否删除角色为:' + row.role + '的数据！', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//编辑
			edit(index, row) {
				this.title = "编辑";
				this.dialogAddFormVisible = true;
				this.addForm.role = row.role;
				this.addForm.status = row.status;

			},
			//权限
			jur() {
				this.dialogqxFormVisible = true
			},
			//添加
			add() {
				this.title = "添加";
				this.addForm.roleN = '';
				this.addForm.role = '';
				this.dialogAddFormVisible = true

			},
			//翻页
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}

		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/system/role.vue